import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { Notification } from '../../models/notification.model';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-notifications-list',
  templateUrl: './notifications-list.component.html',
  styleUrls: ['./notifications-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationsListComponent implements OnInit {
  @Input() showHeader = true;
  @Input() showMarkAllAsRead = true;
  @Output() notificationClick = new EventEmitter<Notification>();
  @Output() notificationDelete = new EventEmitter<number>();
  @Output() markAllAsRead = new EventEmitter<void>();

  notifications$ = this.notificationService.notifications$;
  unreadCount$ = this.notificationService.unreadCount$;
  loading$ = this.notificationService.loading$;
  error$ = this.notificationService.error$;

  isMarkingAllAsRead = false;

  constructor(
      private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.notificationService.initializeNotifications();
  }

  onNotificationClick(notification: Notification): void {
    this.notificationClick.emit(notification);
  }

  async onNotificationVisibilityChanged(event: {notification: Notification, isVisible: boolean}): Promise<void> {
    if (event.isVisible && event.notification.readAt === null) {
      try {
        // Use the fast visibility-based marking method
        await this.notificationService.markAsReadByVisibility(event.notification.id);
        // No need to emit events - the service updates observables automatically
      } catch (error) {
        console.error('Failed to mark notification as read by visibility:', error);
      }
    }
  }

  async onDelete(id: number): Promise<void> {
    try {
      await this.notificationService.deleteNotification(id);
      this.notificationDelete.emit(id);
    } catch (error) {
      console.error('Failed to delete notification:', error);
    }
  }

  async onMarkAllAsRead(): Promise<void> {
    if (this.isMarkingAllAsRead) return;
    
    this.isMarkingAllAsRead = true;
    try {
      await this.notificationService.markAllAsRead();
      this.markAllAsRead.emit();
    } catch (error) {
      console.error('Failed to mark all notifications as read:', error);
    } finally {
      this.isMarkingAllAsRead = false;
    }
  }

  trackByNotificationId(index: number, notification: Notification): number {
    return notification.id;
  }

  onMenuClick(event: Event): void {
    // Keep existing menu functionality if needed
  }
}
